import "./gullygrating.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Gullygrating() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740803999/gully_3_psktgi.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740803999/gully_1_esaebe.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740803999/gully_4_gyrccj.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1740803999/gully_2_djqefj.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Gully Grating || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="We offer production of various styles and sizes of gully gratings for flood drain systems"/>
        <meta name="keywords" content="gully gratings, manhole covers, Lagos Nigeria" />
        </Helmet>
        <h3>Gully Grating</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Features of Our Gully Gratings:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Fracture Resistance 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Corrosion Resistance
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Fatigue Strength
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Ductile
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Gully gratings, also known as stormwater or drainage gratings, are devices installed on the surface of roadways, pavements, or other areas to allow water to drain into the stormwater system while preventing debris from entering the drainage pipes. They are typically placed above roadside gullies or drainage channels.

        Gully gratings help channel rainwater into the underground drainage system or stormwater drains. They direct excess water from streets, pavements, and other surfaces to prevent flooding.
        </div>
    </div>
  )
}
